<template>
  <div>
    <div v-for="(period, index) in timePeriods" :key="index" class="time-period-item">
      <van-field
        :value="formatTimeRange(period)"
        readonly
        clickable
        :disabled="disabled"
        @click="openTimePicker(index)"
        class="custom-field"
        :placeholder="$t('form.selectTimePeriod')"
      />
      <img class="remove-icon" @click="removeTimePeriod(index)" v-if="timePeriods.length > 0" src="@/assets/images/event_del.png" alt="">
    </div>
    <div class="add-time-btn" @click="addTimePeriod">+ {{ $t('button.addMoreTime') }}</div>

    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <div class="time-picker-header">
        <van-button type="default" size="small" @click="showPicker = false">{{ $t('button.cancel') }}</van-button>
        <div style="font-weight: bold;">Select Time</div>
        <van-button type="primary" size="small" @click="onTimeConfirm">{{ $t('button.confirm') }}</van-button>
      </div>
      <div class="time-picker-body">
        <div class="time-picker-column">
          <div class="time-picker-title">{{ $t('form.startTime') }}</div>
          <van-datetime-picker
            v-model="startTime"
            type="time"
            :filter="timeFilter"
          />
        </div>
        <div class="time-picker-column">
          <div class="time-picker-title">{{ $t('form.endTime') }}</div>
          <van-datetime-picker
            v-model="endTime"
            type="time"
            :filter="timeFilter"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'XuTime',
  props: {
    value: {
      type: Array,
      default: () => [{ start: '', end: '' }]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPicker: false,
      startTime: '09:30',
      endTime: '10:30',
      currentTimeIndex: null,
      timePeriods: this.value
    }
  },
  watch: {
    value (newVal) {
      this.timePeriods = newVal
    },
    timePeriods (newVal) {
      this.$emit('input', newVal)
    }
  },
  methods: {
    addTimePeriod () {
      this.timePeriods.push({ start: '', end: '' })
    },
    removeTimePeriod (index) {
      if (this.timePeriods.length > 0) {
        this.timePeriods.splice(index, 1)
      }
    },
    openTimePicker (index) {
      this.currentTimeIndex = index
      const period = this.timePeriods[index]
      this.startTime = period.start || '09:30'
      this.endTime = period.end || '10:30'
      this.showPicker = true
    },
    onTimeConfirm () {
      if (this.startTime >= this.endTime) {
        Toast(this.$t('tips.messageFive'))
        return
      }
      const newPeriods = [...this.timePeriods]
      newPeriods[this.currentTimeIndex] = {
        start: this.startTime,
        end: this.endTime
      }
      this.timePeriods = newPeriods
      this.showPicker = false
    },
    timeFilter (type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 10 === 0)
      }
      return options
    },
    formatTimeRange (period) {
      if (period.start && period.end) {
        return `${period.start}~${period.end}`
      }
      return ''
    }
  }
}
</script>
<style scoped lang="less">
.time-period-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .custom-field {
    flex: 1;
    padding: 5px 10px;
    background: #fff;
    border: 1px solid #b9cbed;
    border-radius: 4px;
  }
  .remove-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
}
.add-time-btn {
  display: inline-block;
  padding: 5px 3px;
  color: #307bff;
  border: 1px solid #307bff;
  background-color: #e4eefc;
  border-radius: 6px;
  font-size: 12px;
}
.time-picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  color: #000;
  /deep/.van-button--primary {
    background-color: #307bff;
    border: none;
  }
}
.time-picker-body {
  display: flex;
  justify-content: center;
  .time-picker-column {
    flex: 1;
    text-align: center;
    .time-picker-title {
      padding: 10px 0;
      font-weight: bold;
    }
  }
}
</style>
